const API_URL = '//' + (process.env.REACT_APP_API_URL ?? 'api.omnigoevents.com') + '/';

const getProtocol = () => window.location.protocol;

const getAuthenticationHeader = (token) =>
    token ? { 'Authentication': `Bearer ${token}` } : {};

const doFetch = async (method = 'GET', path, body, options = {}, token) => {
    const url = `${getProtocol()}${API_URL}${path}`;
    try {
        // adjust options based on method and body
        options = {
            ...options,
            headers: {
                ...(options?.headers ?? {}),
                ...getAuthenticationHeader(token),
                ...(body ? {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                } : {}
                )
            },
            ...(body ? { body: JSON.stringify(body) } : {}),
            method
        };
        const response = await fetch(url, options);
        if (!response.ok) {
            // the API's own explanation, when it gave one, goes before the status so the status stays last
            const message = (await response.json().catch(() => null))?.message;
            throw new Error(`${typeof message === 'string' && message ? `${message}. ` : ''}status: ${response.status}`);
        }
        return await response.json();
    } catch (ex) {
        const msg = `failed to ${method} ${url}. ${ex.message}`;
        console.error({ ex, msg });
        return new Promise((resolve, reject) => reject(msg));
    }
};

const get = async (path, token) =>
    await doFetch('GET', path, null, null, token);

const put = async (path, body, token) =>
    await doFetch('POST', path, body, {}, token);

const patch = async (path, body, token) =>
    await doFetch('POST', path, body, {}, token);

const post = async (path, body, token) =>
    await doFetch('POST', path, body, {}, token);

export default {
    get,
    put,
    patch,
    post,
    doFetch
};
